import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { fr } from 'date-fns/locale';

export function formatDate (date, formatStr) {
  if (formatStr == null) {
    formatStr = 'dd/MM/yyyy';
  }

  if (typeof date === 'string') {
    date = parseISO(date);
  }

  return format(date, formatStr, { locale: fr });
}
